module.exports = __webpack_public_path__ + "img/03-mobile.66527650.jpg";